<template>
    <div>
        <b-button variant="warning" @click.stop="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Empresa </span>
        </b-button>
        <raht-empresa-form
            :mostrarModal="mostrarModal"
            tipo="I"
            @modalFechado="mostrarModal = false"
            @inserirEmpresa="$emit('inserirEmpresa', $event)"
        ></raht-empresa-form>
    </div>
</template>

<script>
import RahtEmpresaForm from './RahtEmpresaForm'

export default {
    components: {
        RahtEmpresaForm
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
